export type Size = 'Fit-Content' | 'Small' | 'Medium' | 'Large';

export function parseStyles(styles: string) {

    let json = '';
    styles.split(';').forEach((style, i) => {

        if (i === 0) {

            json += `{"backgroundColor": "#${style}"`;

        } else {

            const declaration = style.split(':');
            if (declaration.length === 2) {

                json += `,"${declaration[0].trim()}":"${declaration[1].trim()}"`;

            }

        }

    });
    return JSON.parse(json + '}');

}

export const mobileDialogWidth = (size: Size, windowDimensionWidth: number): string => {

    switch (true) {

        case windowDimensionWidth > 1400 && size === 'Fit-Content':
            return 'fit-content';
        case windowDimensionWidth > 1100 && size === 'Fit-Content':
            return 'fit-content';
        case windowDimensionWidth > 900 && size === 'Fit-Content':
            return 'fit-content';
        case size === 'Fit-Content':
            return '100%';
        case windowDimensionWidth > 1400 && size == 'Large':
            return '80%';
        case windowDimensionWidth > 1400 && size == 'Medium':
            return '65%';
        case windowDimensionWidth > 1400 && size == 'Small':
            return '45%';
        case windowDimensionWidth > 1100 && size == 'Large':
            return '95%';
        case windowDimensionWidth > 1100:
            return '65%';
		  default:
            return '100%';

    }

};

export const mobileDialogHeight = (windowDimensionWidth: number, windowDimensionHeight: number) => {

    switch (true) {

        case windowDimensionHeight > 900 && windowDimensionWidth < 800:
            return '100vh';
        case windowDimensionHeight > 700 && windowDimensionWidth < 800:
            return '100vh';
        case windowDimensionHeight > 900:
            return 'fit-content';
        case windowDimensionHeight > 700:
            return '95vh';
        case windowDimensionHeight < 900:
            return 'fit-content';
        default:
            return '100vh';

    }

};

// DEPRECATED
export function merge(...classNames: unknown[]): string {

    let finalClassName = '';
    classNames.forEach(className => {

        if (typeof className === 'string') {

            finalClassName += finalClassName.length > 0 ? ' ' : '';
            finalClassName += className;

        }

    });
    return finalClassName;

}